<template>
  <AppModal
    :use-dimness="true"
    data-test="revision-selector-modal-container"
    @close="$emit('close')"
  >
    <template #modal-header>
      <h3
        id="modal-headline"
        class="text-lg leading-6 font-medium text-gray-900"
        data-test="revision-selector-modal-headline"
      >
        Select Revision
      </h3>
    </template>
    <template #modal-body>
      <div class="py-2">
        <div v-if="isLoading" class="flex justify-center p-4" aria-live="polite" data-test="revision-selector-loading-indicator">
          <BaseIcon icon="spinner" size="lg" spin aria-hidden="true" />
          <span class="sr-only">Loading revisions</span>
        </div>
        <ul 
          v-else 
          class="divide-y divide-gray-200 max-h-80 overflow-y-auto"
          aria-label="List of available revisions"
          role="listbox"
          tabindex="0"
          data-test="revision-selector-revisions-list"
        >
          <li 
            v-for="revision in revisions" 
            :key="revision.id"
            class="px-4 py-3 cursor-pointer hover:bg-blue-50 transition-colors flex items-center"
            role="option"
            :aria-selected="isRevisionSelected(revision)"
            tabindex="0"
            :data-test="`revision-selector-item-${revision.id}`"
            @click="selectRevision(revision)"
            @keydown.enter="selectRevision(revision)"
            @keydown.space.prevent="selectRevision(revision)"
          >
            <div class="w-6 flex-shrink-0">
              <BaseIcon 
                v-if="isRevisionSelected(revision)" 
                icon="angle-right" 
                class="text-gray-600"
                aria-hidden="true" 
                data-test="revision-selector-selected-icon"
              />
            </div>
            <div>
              {{ revision.revisionLabel }}
              <span v-if="isRootRevision(revision)" class="ml-1 text-sm text-gray-500" data-test="revision-selector-current-label">(current)</span>
            </div>
          </li>
          <li v-if="!revisions.length" class="px-4 py-3 text-gray-500 text-center" role="status" data-test="revision-selector-empty-message">
            No revisions available
          </li>
        </ul>
      </div>
    </template>
    <template #modal-footer>
      <div class="pt-0 pb-4 px-4 flex justify-end">
        <button
          aria-label="Close Revision Selector"
          type="button"
          class="ml-2 rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 transition ease-in-out duration-150 sm:text-sm sm:leading-5 ui-font"
          data-test="revision-selector-close-button"
          @click="$emit('close')"
        >
          CLOSE
        </button>
      </div>
    </template>
  </AppModal>
</template>

<script>
import AppModal from '@/components/AppModal'

export default {
  name: 'RevisionSelectorModal',
  components: {
    AppModal
  },
  props: {
    revisions: {
      type: Array,
      default: () => []
    },
    selectedRevision: {
      type: Object,
      default: () => null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    rootRevision: {
      type: Object,
      default: () => null
    }
  },
  emits: ['close', 'select'],
  methods: {
    selectRevision(revision) {
      this.$emit('select', revision)
    },
    isRevisionSelected(revision) {
      if (!this.selectedRevision) return false
      return this.selectedRevision.id === revision.id
    },
    isRootRevision(revision) {
      if (!this.rootRevision || !revision) return false
      return revision.id === this.rootRevision.id
    }
  }
}
</script>
